






















import { Component, Vue } from 'vue-property-decorator'
import { $myPeer } from '@/index'
import { GameModule, PeerModule } from '@/store'

@Component
export default class Words extends Vue {
  $peer: $myPeer;

  get players () {
    return GameModule.players
  }

  created () {
    PeerModule.ready()
  }

  start () {
    GameModule.startGame()
    PeerModule.sendMessage({ type: 'START' })
  }

  get isActivePlayer () {
    return GameModule.activePlayer && GameModule.activePlayer.id === GameModule.playerId
  }

  isMine (playerId) {
    return playerId === GameModule.playerId
  }
}
